module.exports = __webpack_public_path__ + "static/media/customize.20411bfc.svg";